<template>
    <Modal
        id="create-platform-modal"
        ref="create-platform-modal"
        v-model:open="open"
        title="create_platform"
        width="xl"
        @submit="submit"
        @cancel="cancel"
    >
        <TextField
            v-model="modelValue.platform_name"
            label="platform_name"
            name="platform_name"
            :required="true"
            help="help_platform_name"
        />

        <SelectField
            v-model="modelValue.parent_platform_name"
            v-model:options="parentPlatformOptions"
            name="parent_platform_name"
            label="parent_platform_name"
            help="help_parent_platform_name"
            :on-search="loadParentPlatformOptions"
        />

        <TextField
            v-model="modelValue.platform_url"
            label="url"
            name="platform_url"
            :required="true"
            help="help_platform_url"
        />

        <template #actions>
            <MultiActionButton />
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { useMultiActionButton } from '@composables/common'
import { Modal, SelectField, TextField } from '@src/components'
import { Platform } from '@src/types'
import { getPlatforms } from '@src/utils/api/platforms'
import { useVModels } from '@vueuse/core'
import { computed, ref } from 'vue'

const props = defineProps<{
    open: boolean
    modelValue: Platform
}>()

const emit = defineEmits([
    'update:modelValue',
    'update:open',
    'cancel',
    'submit',
])

const { modelValue, open } = useVModels(props, emit)

const parentPlatformOptions = ref<string[]>([])

async function loadParentPlatformOptions(search: string) {
    const initialPlatformsRequest = await getPlatforms({
        'filter[platform_name]': search,
        'filter[is_not_child]': true,
    })
    parentPlatformOptions.value = initialPlatformsRequest.data.platforms.map(
        (platform: Platform) => {
            return platform.platform_name as string
        }
    )
}

const { MultiActionButton } = useMultiActionButton({
    id: 'create-platform-button',
    actions: [
        {
            label: 'create',
            action: submit,
            disabled: () => disableCreate.value,
        },
        {
            label: 'create_and_view',
            action: submitAndView,
            disabled: () => disableCreate.value,
        },
        {
            label: 'create_and_edit',
            action: submitAndEdit,
            disabled: () => disableCreate.value,
        },
    ],
})

function cancel() {
    emit('cancel')
}

function submit() {
    emit('submit')
}

function submitAndView() {
    emit('submit', 'view')
}

function submitAndEdit() {
    emit('submit', 'edit')
}

const disableCreate = computed(() => {
    return !modelValue.value.platform_name || !modelValue.value.platform_url
})
</script>
